import { cn } from "@/lib/utils";
import { CheckIcon } from "@phosphor-icons/react";
import { ListBoxItem } from "react-aria-components";
import type { ListItemProps } from "./Autocomplete.type";

export const AutocompleteListItem = <TValue,>({
  item,
  selectedKey,
  className,
  ...props
}: ListItemProps<TValue>) => (
  <ListBoxItem
    {...props}
    key={item.id}
    id={item.id}
    className={cn(
      "relative flex cursor-pointer select-none items-center justify-between gap-1.5 rounded-xs px-3 py-1 text-sm outline-hidden transition-colors",
      "data-disabled:pointer-events-none data-disabled:opacity-50",
      "data-focused:bg-gray-50 data-focused:text-gray-900",
      "data-pressed:bg-gray-100",
      "text-gray-700 font-normal text-xs tracking-wide",
      item.isNoneOption && "italic",
      className,
    )}
    textValue={item.label}
  >
    <span
      className={cn(item.isNoneOption && "flex items-center gap-1")}
      data-option={item.label}
    >
      {item.isNoneOption ? (
        <>
          <span className="text-gray-200">&mdash;</span>
          {item.label}
          <span className="text-gray-200">&mdash;</span>
        </>
      ) : (
        item.label
      )}
    </span>
    {((item.isNoneOption && (!selectedKey || selectedKey === "__none__")) ||
      (!item.isNoneOption && selectedKey === item.id)) && (
      <CheckIcon className="size-4" />
    )}
  </ListBoxItem>
);
